export function initLightDarkSwitchEx() {
  function addClass(element, className) {
    if (element.classList) {
      element.classList.add(className);
    } else {
      element.className += ' ' + className;
    }
  }

  function removeClass(element, className) {
    if (element.classList) {
      element.classList.remove(className);
    } else {
      element.className = element.className.replace(
        new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
        ' '
      );
    }
  }

  (function () {
    var LdSwitch = function (element) {
      this.element = element;
      this.icons = this.element.getElementsByClassName('js-ld-switch-icon');
      this.button = this.element.querySelector('.js-ld-switch-toggle');
      this.label = this.element.querySelector('.js-ld-switch-label');
      this.selectedIcon = 1; // Default to dark mode (moon icon)
      initLdSwitch(this);
    };

    function initLdSwitch(switchOb) {
      // Set initial state
      setStartState(switchOb);

      if (switchOb.button) {
        switchOb.button.addEventListener('click', function () {
          var nextValue = switchOb.selectedIcon === 1 ? 0 : 1;
          setTheme(switchOb, nextValue);
        });
      }
    }

    function setStartState(switchOb) {
      var savedTheme = localStorage.getItem('ldSwitch');
      var selectedOptionIndex = 1; // default to dark

      if (!savedTheme) {
        // Default to dark mode on first visit
        setTheme(switchOb, selectedOptionIndex, true);
      } else {
        selectedOptionIndex = savedTheme === 'dark' ? 1 : 0; // Dark = moon (1), Light = sun (0)
        setTheme(switchOb, selectedOptionIndex, true);
      }
    }

    function setTheme(switchOb, value, init) {
      var theme = value === 1 ? 'dark' : 'light'; // Ensure correct mapping
      var iconIndex = value; // Match value to icon index

      // Update local storage with the selected theme and icon index
      localStorage.setItem('ldSwitch', theme);
      localStorage.setItem('ldSwitchIcon', iconIndex);

      // Update theme value
      updateThemeValue(theme);

      // Update visible icon
      updateIcon(switchOb, iconIndex, switchOb.selectedIcon, init);

      // Update button state
      updateButtonState(switchOb, theme, iconIndex);
    }

    function updateIcon(switchOb, newIcon, oldIcon, init) {
      if (init) {
        // Setting the initial status of the switcher
        switchOb.selectedIcon = newIcon;
        for (var i = 0; i < switchOb.icons.length; i++) {
          removeClass(switchOb.icons[i], 'ld-switch-btn__icon-wrapper--in');
        }
        addClass(switchOb.icons[newIcon], 'ld-switch-btn__icon-wrapper--in');
        return;
      }

      removeClass(switchOb.icons[oldIcon], 'ld-switch-btn__icon-wrapper--in');
      addClass(switchOb.icons[oldIcon], 'ld-switch-btn__icon-wrapper--out');

      addClass(switchOb.icons[newIcon], 'ld-switch-btn__icon-wrapper--in');

      switchOb.icons[newIcon].addEventListener('transitionend', function cb() {
        removeClass(switchOb.icons[oldIcon], 'ld-switch-btn__icon-wrapper--out');
        switchOb.icons[newIcon].removeEventListener('transitionend', cb);
        switchOb.selectedIcon = newIcon;
      });
    }

    function updateThemeValue(theme) {
      document.documentElement.setAttribute('data-theme', theme);
    }

    function updateButtonState(switchOb, theme, iconIndex) {
      if (!switchOb.button) return;

      var isDark = theme === 'dark';
      switchOb.button.setAttribute('aria-pressed', isDark ? 'true' : 'false');

      if (switchOb.label) {
        switchOb.label.textContent = 'Toggle color theme (currently ' + theme + ')';
      }

      switchOb.selectedIcon = iconIndex;
    }

    window.LdSwitch = LdSwitch;
    var ldSwitches = document.getElementsByClassName('js-ld-switch');
    if (ldSwitches.length > 0) {
      for (var i = 0; i < ldSwitches.length; i++) {
        new LdSwitch(ldSwitches[i]);
      }
    }
  })();
}